import { type SxProps, type Theme } from '@mui/system';
import Bg from '../../assets/login-background.png';

const INFO_WIDTH = 500;

export const contentSx: SxProps<Theme> = {
  display: 'inline-block',
  padding: {
    xs: '26px',
    md: '32px 30px',
    lg: '32px 150px',
  },
  width: '100%',
  minHeight: '100vh',
  background: `url(${Bg})`,
  backgroundSize: 'cover',
  overflowY: 'auto',
};

export const titleSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  '& .title': {
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '34px',
    color: '#006EC2',
  },
  // TODO: independent
  '& .legend': {
    display: 'block',
    width: '10px',
    height: '10px',
    marginLeft: '30px',
    marginRight: '8px',
    borderRadius: '2px',
  },
  '& .completed': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#006EC2',
    '& .legend': {
      background: '#006EC2',
    },
  },
  '& .processing': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#707070',
    '& .legend': {
      background: '#707070',
    },
  },
  '& .course-search': {
    height: '35px',
    border: '1px solid #006EC2',
    width: {
      xs: 'auto',
      md: '280px',
    },
    outline: 'none !important',
    marginLeft: '10px',
    borderRadius: '3px',
    paddingRight: '35px',
  },
};

export const courseListSx: SxProps<Theme> = {
  marginTop: '20px',
  '& .iframe-wrapper': {
    width: '100vw',
    height: '100vh',
    zIndex: 100,
    background: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    '& .iframe-controller': {
      width: {
        xs: 'calc(100vw - 20px)',
        lg: '1080px',
      },
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      gap: '6px',
      '& .bi-arrows-fullscreen': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '26px',
        color: '#FFFFFF',
        cursor: 'pointer',
        verticalAlign: 'middle',
      },
      '& .bi-x': {
        fontSize: '48px',
        color: '#FFFFFF',
        cursor: 'pointer',
      },
    },
    '& iframe': {
      width: {
        xs: 'calc(100vw - 20px)',
        lg: '1080px',
      },
      height: {
        xs: 'calc(100vh - 100px)',
        lg: '720px',
      },
    },
  },
};

export const courseCardSx: SxProps<Theme> = {
  position: 'relative',
  background: '#FFFFFF',
  margin: '0px 0px 13px 0px',
  maxHeight: {
    xs: '360px',
    md: 'none',
  },
  height: {
    xs: 'auto',
    md: '198px',
  },
  width: {
    xs: '360px',
    md: 'auto',
  },
  boxShadow: '0px 3px 6px #00000029',
  padding: '15px 16px',
  boxSizing: 'border-box',
  borderLeft: '2px solid #006ec2',
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  '& .thumbnail': {
    aspectRatio: '16/9',
    width: 'auto',
    maxHeight: '154px',
    marginRight: {
      xs: '0px',
      md: '20px',
      lg: '40px',
    },
  },
  '& .wrapper': {
    flex: 1,
    wordBreak: 'break-word',
  },
  '& .title': {
    color: '#006ec2',
    fontSize: '28px',
    lineHeight: '34px',
    fontWeight: 'bold',
    marginBottom: '2px',
    '& .mandatory': {
      fontSize: '14px',
      background: '#006EC2',
      padding: '2px 4px',
      display: 'inline-block',
      lineHeight: '17px',
      borderRadius: '2px',
      color: '#FFFFFF',
      marginLeft: '14px',
      fontWeight: 400,
    },
  },
  '& .info': {
    fontSize: '18px',
    color: '#006EC2',
    display: 'flex',
    alignItems: 'center',
  },

  '& .content': {
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
    marginTop: '8px',
  },

  '& .completed': {
    position: 'absolute',
    top: '147px',
    left: '16px',
    width: '273px',
    fontSize: '14px',
    background: '#006EC2',
    textAlign: 'center',
    color: '#FFFFFF',
    padding: '2px 0px',
  },
};

export const courseDialogSx: SxProps<Theme> = {
  position: 'absolute',
  '& .MuiPaper-root': {
    padding: '34px 39px 0px 38px',
    minWidth: '940px',
    width: '940px',
    height: '352px',
    boxSizing: 'border-box',
  },
  '& .MuiDialogContent-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    flexDirection: 'column',
    paddingTop: '51px',
  },
  '& .content': {
    color: '#006EC2',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 'bold',
  },
  '& .bi-x': {
    position: 'absolute',
    top: '13.5px',
    right: '39px',
    cursor: 'pointer',
    fontSize: '28px',
    color: '#006EC2',
  },
  '& .title': {
    color: '#006EC2',
    fontSize: '28px',
    lineHeight: '34px',
    fontWeight: 'bold',
    borderBottom: '2px solid #ECECEC',
  },
  '& .button': {
    marginTop: '62px',
    width: '132px',
    height: '32px',
    color: '#FFFFFF',
    background: '#006EC2',
  },
};

export const infoSx: SxProps<Theme> = {
  display: 'inline-block',
  background: 'rgb(228, 239, 247)',
  width: `${INFO_WIDTH}px`,
  padding: '22px 25px',
  boxSizing: 'border-box',
};

/***********************/
/** ** Course History ***/
/***********************/

export const historySx: SxProps<Theme> = {
  boxShadow: '0px 3px 6px #00000029',
  background: '#FFF',
  padding: '22px',
  '& .title-wrapper': {
    display: 'flex',
    borderBottom: 'solid 2px #ececec',
    paddingBottom: '13px',
  },
  '& .rule-icon': {
    width: '53px',
    height: '53px',
    marginRight: '32px',
  },
  '& .title': {
    fontSize: '28px',
    lineHeight: '34px',
    color: '#000',
    fontWeight: 'bold',
  },
  // TODO: independent
  '& .legend': {
    display: 'block',
    width: '10px',
    height: '10px',
    marginRight: '8px',
    borderRadius: '2px',
  },
  '& .completed': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#006EC2',
    '& .legend': {
      background: '#006EC2',
    },
  },
  '& .processing': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#707070',
    '& .legend': {
      marginLeft: '30px',
      background: '#707070',
    },
  },
  '& .navigation-row': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '24px',
    marginTop: '20px',
    '& .type': {
      color: '#000',
      fontWeight: 'bold',
      textTransform: 'capitalize',
    },
    '& .arrow': {
      cursor: 'pointer',
      '&.disabled': {
        opacity: 0.5,
        pointerEvents: 'none',
      },
    },
  },
};

export const historyRowSx: SxProps<Theme> = {
  color: '#006EC2',
  fontSize: '18px',
  lineHeight: '22px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  borderBottom: 'solid 2px #ECECEC',
  margin: '18px 20px 0px 20px',
  '& .name': {
    fontWeight: 'bold',
  },
};

export const badgesSx: SxProps<Theme> = {
  marginTop: '22px',
  '& .title': {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '22px',
    marginLeft: '16px',
  },
  '& .badges-wrapper': {
    background: '#fff',
    paddingTop: '15px',
    display: 'flex',
    flexWrap: 'wrap',
    boxShadow: '0px 3px 6px #00000029',
  },
};

export const badgeInfoSx: SxProps<Theme> = {
  width: '25%',
  margin: '0px 4%',
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 'bold',
  color: '#000',
  textAlign: 'center',
  marginBottom: '30px',
  '& .badge-title': {
    height: '44px',
  },
  '& .badge-img': {
    width: '100%',
  },
  '& .MuiLinearProgress-root': {
    width: '82px',
    margin: '8px auto 0px',
  },
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#006EC2',
  },
};
